import { z } from "zod";

export const getProductsReviewsRatings = {
  input: z.array(z.string()),
  output: z.record(
    z.string(),
    z.object({ rating: z.number(), numReviews: z.number() }).nullable(),
  ),
};
